import { createAction } from 'redux-actions';

export const setRootProgram = createAction('SET_ROOT_PROGRAM');